// extracted by mini-css-extract-plugin
module.exports = {"icon":"BudgetRangePopover--icon","wrapper":"BudgetRangePopover--wrapper","title":"BudgetRangePopover--title","item":"BudgetRangePopover--item"};